// extracted by mini-css-extract-plugin
export default {"filtersContainer":"Filters_filtersContainer__bGXEj"};